/** Pure selected-route toll marker data, kept separate from Mapbox lifecycle. */

import type { Route } from '../core/types';
import { romaniseThai } from '../core/translit';
import { routeTollPoints, type RouteTollPoint } from '../nav/tolls';

export type TollLabelLanguage = 'en' | 'local';

function markerLabel(
  point: RouteTollPoint,
  gantry: boolean,
  labelLang: TollLabelLanguage,
): string {
  if (point.name) {
    if (labelLang === 'local') return point.name;
    return romaniseThai(point.name) || point.name;
  }
  if (labelLang === 'local') {
    return gantry ? 'จุดเก็บค่าผ่านทางอัตโนมัติ' : 'ด่านเก็บเงิน';
  }
  return gantry ? 'ETC' : 'TOLL';
}

export function routeTollMarkerData(
  route: Route | null | undefined,
  labelLang: TollLabelLanguage,
): GeoJSON.FeatureCollection {
  return {
    type: 'FeatureCollection',
    features: routeTollPoints(route).map((point) => {
      const gantry = point.type === 'toll_gantry';
      return {
        type: 'Feature' as const,
        properties: {
          kind: gantry ? 'gantry' : 'booth',
          glyph: gantry ? 'E' : '฿',
          label: markerLabel(point, gantry, labelLang),
        },
        geometry: { type: 'Point' as const, coordinates: point.location },
      };
    }),
  };
}
